import React from 'react';
import { useLocation } from 'react-router-dom';
import { LocalizedLink } from 'src/components/common/LocalizedLink';
import { HotelDetailImageSlider } from '../monthly/HotelDetailImageSlider';
import { FloorPlanModal } from '../common/FloorPlanModal';
import { AmenityModal } from '../common/AmenityModal';

interface ImageData {
  src: string;
  alt: string;
  text: string;
}

interface AvailabilityItem {
  year_month: string;
  early: number;
  mid: number;
  late: number;
}

interface HotelALLReservationTableProps {
  studioType: string;
  propertyId: string;
  propertyChillenId: string;
  roomChillenId: string;
  images: ImageData[];
  roomDescription: string;
  availabilityOverview?: AvailabilityItem[];
  floorPlanUrl?: string;
  facility?: string[];
  facility_en?: string[];
  bathAmenity?: string[];
  bathAmenity_en?: string[];
  roomId?: string;
  price?: number;
  station_distance?: string;
  isShow?: boolean;
  useRoomDetail?: boolean;
}

export const HotelALLReservationTable: React.FC<
  HotelALLReservationTableProps
> = ({
  propertyId,
  propertyChillenId,
  roomChillenId,
  studioType,
  images,
  roomDescription,
  floorPlanUrl,
  facility,
  facility_en,
  bathAmenity,
  bathAmenity_en,
  price,
  station_distance,
}) => {
  const location = useLocation();
  const langSegment = location.pathname.split('/')[1];
  const useEnglish = langSegment === 'en';

  const isPropertyPage =
    window.location.pathname.includes('property') ||
    window.location.pathname.includes('properties');

  const isHotelPropertiesPage =
    window.location.pathname.includes('hotel/properties');

  // Book Now ボタンの外部リンク先
  const bookNowLink = `https://www.chillnn.com/${propertyChillenId}`;

  return (
    <div className="relative my-3">
      <div className="flex flex-col md:flex-row-reverse">
        {/* 画像スライダー */}
        <div className="md:w-3/5">
          <HotelDetailImageSlider images={images} />
        </div>

        {/* テキスト情報 */}
        <div className="md:w-2/5">
          <div>
            <div className="mb-1 max-md:mt-2 mr-5">
              <p
                className="text-[10px]"
                dangerouslySetInnerHTML={{
                  __html: roomDescription,
                }}
              />
              <p className="text-2xl my-3 underline">{studioType}</p>
              <p
                className="text-xs mb-3"
                dangerouslySetInnerHTML={{ __html: station_distance || '' }}
              />
              {price !== undefined && (
                <p className="text-base">
                  {price} {useEnglish ? '/Night ~' : '円/泊 ～'}
                </p>
              )}
            </div>

            <div className="flex md:mt-10 mt-5 items-center space-x-2 max-md:justify-center">
              {isPropertyPage && (
                <LocalizedLink
                  to={`/hotel/${propertyId}`}
                  className="flex items-center justify-center text-black border border-black text-[15px] w-[8.5rem] h-[2.125rem]"
                >
                  {useEnglish ? 'View Property' : '物件を見る'}
                </LocalizedLink>
              )}

              {/* Book Now ボタン：外部リンク */}
              <a
                href={bookNowLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center text-white bg-black text-[15px] font-bold text-center w-[7.5rem] h-[2.125rem]"
              >
                {useEnglish ? 'Book Now' : '予約する'}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* モーダル類：表示条件に応じて */}
      {!isHotelPropertiesPage && (
        <div className="md:absolute md:left-0 md:bottom-2 flex md:justify-center text-xs max-md:text-center max-md:mt-5">
          <FloorPlanModal floorPlanUrl={floorPlanUrl} />
          <AmenityModal
            facility={facility}
            facility_en={facility_en}
            bathAmenity={bathAmenity}
            bathAmenity_en={bathAmenity_en}
          />
        </div>
      )}
    </div>
  );
};
